import { marketplaceOrderDisclaimer } from '@/platform/legal/marketplacePolicy';
import { siteBrandName } from '@/platform/legal/siteLegal';

export function MarketplaceOrderDisclaimer() {
  return (
    <aside className="marketplace-order-disclaimer" role="note">
      <p>{marketplaceOrderDisclaimer(siteBrandName())}</p>
    </aside>
  );
}
